import {getOptions, getIntelTaregtStatus, getDesignTaregtStatus} from './format.js';

export const tabConfig = [
    {
        label: '智能生成',
        name: 'intelForm',
        value: 'intelForm'
    },
    {
        label: '高级设计',
        name: 'designForm',
        value: 'designForm'
    }
];

export const textAuditRefusedMessage = {
    message: '请合规使用本平台，不支持带有敏感信息的内容输入',
    duration: 5000
};

export const imagePartRefusedMessage = {
    message: '部分敏感信息已被过滤',
    duration: 5000
};

export const defaultIntelTarget = {
    targetCount: 4,
    options: getOptions(4, 6)
};

export const defaultDesignTarget = {
    targetCount: 1,
    options: getOptions(1, 9)
};

export const formToFunctionMap = {
    intelFormData: {
        getStatus: getIntelTaregtStatus,
        formName: 'intelForm',
        max: 6
    },
    designFormData: {
        getStatus: getDesignTaregtStatus,
        formName: 'designForm',
        max: 9
    }
};

export const placeHolder = {
    page: 'market',
    title: '营销图生成',
    subtitle: '快速生成图片，可快速进行局部优化',
    src: 'https://qiaojiang.bj.bcebos.com/fe/static/images/Demo_MarketGenerate%404x.mp4'
};

export const historyParams = {
    pageNo: 1,
    pageSize: 20,
    taskType: [13, 14, 15, 16, 5]
};

export const btbIndustry = [
    '机械设备',
    '化工及能源',
    '农林牧渔',
    '电子电工'
];

export const normalIndustry = [
    '全部',
    '房产家居',
    '旅游服务',
    '交通出行',
    '整形美容',
    '教育培训',
    '金融服务',
    '商品交易',
    '医疗服务',
    '生活服务',
    '文娱传媒',
    '商务服务',
    '游戏',
    '软件',
    '网络服务',
    '通信'
];

export const openIndustry = [
    ...normalIndustry,
    ...btbIndustry
];

export const ratioMaxLengthMap = {
    'btb': {
        businessPointB2B: 20,
        sellingPointFirst: 5,
        sellingPointSecond: 5,
        sellingPointThird: 5,
        manufacturerName: 12
    },
    '1:1': {
        mainText: 8,
        descText: 12,
        buttonText: 4,
        otherText: 10
    },
    'base': {
        mainText: 12,
        descText: 14,
        buttonText: 6,
        otherText: 14
    }
};

export const designSizeOptions =  [
    {
        value: '1:1',
        label: '比例1:1',
        children: [
            {
                value: '240*240',
                label: '尺寸240*240'
            }, {
                value: '220*220',
                label: '尺寸220*220'
            }, {
                value: '360*360',
                label: '尺寸360*360'
            }, {
                value: '480*480',
                label: '尺寸480*480'
            }, {
                value: '600*600',
                label: '尺寸600*600'
            }, {
                value: '300*300',
                label: '尺寸300*300'
            }
        ]
    }, {
        value: '3:2',
        label: '比例3:2',
        children: [
            {
                value: '370*245',
                label: '尺寸370*245'
            }, {
                value: '960*640',
                label: '尺寸960*640'
            }, {
                value: '1200*800',
                label: '尺寸1200*800'
            }, {
                value: '900*600',
                label: '尺寸900*600'
            }, {
                value: '300*200',
                label: '尺寸300*200'
            }
        ]
    }, {
        value: '16:9',
        label: '比例16:9',
        children: [
            {
                value: '1140*640',
                label: '尺寸1140*640'
            }, {
                value: '1280*720',
                label: '尺寸1280*720'
            }, {
                value: '1600*900',
                label: '尺寸1600*900'
            }, {
                value: '1920*1080',
                label: '尺寸1920*1080'
            }, {
                value: '960*540',
                label: '尺寸960*540'
            }
        ]
    }
];

export const intelSizeOptions = [
    {
        value: '1:1',
        label: '比例1:1',
        children: [
            {
                value: '240*240',
                label: '尺寸240*240'
            }, {
                value: '120*120',
                label: '尺寸120*120'
            }, {
                value: '80*80',
                label: '尺寸80*80'
            }, {
                value: '220*220',
                label: '尺寸220*220'
            }, {
                value: '250*250',
                label: '尺寸250*250'
            }, {
                value: '60*60',
                label: '尺寸60*60'
            }, {
                value: '360*360',
                label: '尺寸360*360'
            }, {
                value: '480*480',
                label: '尺寸480*480'
            }, {
                value: '600*600',
                label: '尺寸600*600'
            }, {
                value: '300*300',
                label: '尺寸300*300'
            }
        ]
    }, {
        value: '2:1',
        label: '比例2:1',
        children: [
            {
                value: '800*400',
                label: '尺寸800*400'
            }, {
                value: '600*300',
                label: '尺寸600*300'
            }
        ]
    }, {
        value: '3:2',
        label: '比例3:2',
        children: [
            {
                value: '370*245',
                label: '尺寸370*245'
            }, {
                value: '960*640',
                label: '尺寸960*640'
            }, {
                value: '378*252',
                label: '尺寸378*252'
            }, {
                value: '1200*800',
                label: '尺寸1200*800'
            }, {
                value: '900*600',
                label: '尺寸900*600'
            }, {
                value: '300*200',
                label: '尺寸300*200'
            }
        ]
    }, {
        value: '2:3',
        label: '比例2:3',
        children: [
            {
                value: '1080*1620',
                label: '尺寸1080*1620'
            }, {
                value: '1242*1863',
                label: '尺寸1242*1863'
            }
        ]
    }, {
        value: '3:1',
        label: '比例3:1',
        children: [
            {
                value: '1200*400',
                label: '尺寸1200*400'
            }, {
                value: '1152*384',
                label: '尺寸1152*384'
            }, {
                value: '900*300',
                label: '尺寸900*300'
            }
        ]
    }, {
        value: '4:3',
        label: '比例4:3',
        children: [
            {
                value: '800*600',
                label: '尺寸800*600'
            }, {
                value: '120*90',
                label: '尺寸120*90'
            }
        ]
    }, {
        value: '9:16',
        label: '比例9:16',
        children: [
            {
                value: '1080*1920',
                label: '尺寸1080*1920'
            }, {
                value: '1242*2208',
                label: '尺寸1242*2208'
            }, {
                value: '720*1280',
                label: '尺寸720*1280'
            }
        ]
    }, {
        value: '16:9',
        label: '比例16:9',
        children: [
            {
                value: '1140*640',
                label: '尺寸1140*640'
            }, {
                value: '1280*720',
                label: '尺寸1280*720'
            }, {
                value: '1600*900',
                label: '尺寸1600*900'
            }, {
                value: '1920*1080',
                label: '尺寸1920*1080'
            }, {
                value: '960*540',
                label: '尺寸960*540'
            }
        ]
    }
];